import ProductStatus from './product-status';
export default ProductStatus;